import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FatigueService } from 'src/app/services/fatigue.service';
import { UtilityService } from 'src/app/services/utility.service';
import { workloadFatiuge, AttentionFatiuge } from '../../_models/staticArray'
@Component({
  selector: 'app-default-fatigue-values',
  templateUrl: './default-fatigue-values.component.html',
  styleUrls: ['./default-fatigue-values.component.scss']
})
export class DefaultFatigueValuesComponent implements OnInit {
  defaultFatigue: FormGroup
  loading: boolean = false;
  workloadFatiuge = workloadFatiuge
  attentionFatiuge = AttentionFatiuge
  data: any;
  isEdit: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private _fatigueService: FatigueService,
    public _utilityService: UtilityService,
  ) { }

  ngOnInit() {
    // console.log("this is the AttentionFatiuge", AttentionFatiuge);

    this.getForm()
    if (!this.data) this.createForm()
  }


  // CREATE FORM

  createForm(data?) {
    console.log("What is the data of default value", data);

    this.defaultFatigue = this.formBuilder.group({
      commutingTime: new FormControl((data && data.commutingTime) ? data.commutingTime : '00:40'),
      jobTypeWorkload: new FormControl((data && data.jobTypeWorkload) ? data.jobTypeWorkload : "2"),
      jobTypeAttention: new FormControl((data && data.jobTypeAttention) ? data.jobTypeAttention : "1"),
      frequentlyRestBreak: new FormControl((data && data.frequentlyRestBreak) ? data.frequentlyRestBreak : '03:00'),
      workBeforeBreak: new FormControl((data && data.workBeforeBreak) ? data.workBeforeBreak : '06:00'),
      typicalAverageBreak: new FormControl((data && data.typicalAverageBreak) ? data.typicalAverageBreak : '00:15'),
      breakAfterContinuousWork: new FormControl((data && data.breakAfterContinuousWork) ? data.breakAfterContinuousWork : '00:30'),
    })
    console.log("Value of Current Form", this.defaultFatigue.value);

  }

  // UTILITY FUNCTION
  timeChanged(event) {
    console.log("event  ", event);
  }


  // API CALL

  submit() {
    console.log("this.defaultFatigue.value----->", this.defaultFatigue.value);
    this.loading = true
    if (this.defaultFatigue.valid) {
      if (this.isEdit) {
        let obj = {
          _id: this.data._id,
          details: this.defaultFatigue.value,
        }
        this._fatigueService.editCalculationForm(obj).subscribe((res) => {
          console.log("res get here - - - > ", res);
          if (res == undefined) return
          else
            this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.loading = false
        })
      } else {
        let obj = {
          details: this.defaultFatigue.value,
          title: 'Fatigue/Risk Assessment',
          type: 'fatigue'
        }
        console.log("OBJ DATA", obj);
        this._fatigueService.addCalculationForm(obj).subscribe((res) => {
          console.log("res get here - - - > ", res);
          if (res == undefined) return
          else
            this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.loading = false
        })
      }
    } else {
      this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
    }
  }

  getForm() {
    this.loading = true
    this._fatigueService.getCalculationForm().subscribe((res) => {
      console.log("res get here - - - > ", res);
      if (res == undefined) return
      else {
        this.data = res
        this.isEdit = true
        this.createForm(this.data.details)
      }
      this.loading = false
    }, err => {
      console.log("err in get function ", err);
    })
    this.loading = false
  }

}
